module.exports = __webpack_public_path__ + "img/page logo copy 2.fc92d69a.png";